import React from "react";
import { SignupForm } from "./SignupForm";
import { SignupImg } from "../../../assets/index";
import { Row } from "antd";
import "../../../css/public.css";

export function SignUp() {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
          overflowY: "auto",
          height: "100vh",
        }}
        className="row-public-index"
      >
        <SignupForm />
      </Row>
      <img style={{ height: "100vh" }} src={SignupImg} alt="logo" />
    </div>
  );
}
